var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('content-entity-thumbnail-link');
import { breakpoints, theme } from '@shapeable/theme';
import { EntityLink } from './entity-link';
import { ImageEntity } from './image-entity';
import { useEntity } from '../../hooks/use-entity';
import { first, filter } from 'lodash';
import { useComponentColor } from '../../hooks/use-component-color';
export var ContentEntityThumbnailLinkDefaultProps = {
  aspectRatio: {
    base: 16 / 9,
    landscape: 21 / 9,
    tablet: 16 / 9
  }
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var _color = _a._color,
        _hoverColor = _a._hoverColor;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", ";\n\n      &:hover {\n        color: ", ";\n      }\n    "], ["\n      color: ", ";\n\n      &:hover {\n        color: ", ";\n      }\n    "])), _color, _hoverColor);
  })
});
var ImageStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TitleStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: ", ";\n    margin-bottom: ", ";\n  "], ["\n    font-size: ", ";\n    margin-bottom: ", ";\n  "])), theme.FONT_SIZE(16), theme.UNIT(1))
});
var SubtitleStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-size: ", ";\n    color: ", ";\n    text-transform: uppercase;\n    margin: 0;\n    margin-bottom: ", ";\n  "], ["\n    font-size: ", ";\n    color: ", ";\n    text-transform: uppercase;\n    margin: 0;\n    margin-bottom: ", ";\n  "])), theme.FONT_SIZE(15), theme.COLOR("secondary"), theme.UNIT(4))
});
var BodyStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding-bottom ", ";\n  "], ["\n    padding-bottom ", ";\n  "])), theme.UNIT(6)),
  tablet: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    padding-bottom ", ";\n    padding-right: ", ";\n  "], ["\n    padding-bottom ", ";\n    padding-right: ", ";\n  "])), theme.UNIT(4), theme.UNIT(4))
}); // -------- Components -------->

var My = {
  Container: styled(EntityLink)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Image: styled(ImageEntity)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Title: styled.h2.attrs(cls.attr('title'))(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Subtitle: styled.h3.attrs(cls.attr('subtitle'))(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), SubtitleStyles)
};
export var ContentEntityThumbnailLink = function ContentEntityThumbnailLink(props) {
  var className = props.className,
      children = props.children,
      aspectRatio = props.aspectRatio;
  var entity = useEntity(props.entity);
  var name = entity.name,
      banner = entity.banner,
      _a = entity.imageAssets,
      imageAssets = _a === void 0 ? [] : _a,
      title = entity.title,
      subtitle = entity.subtitle;
  var image = first(filter(__spreadArray(__spreadArray([], __read(imageAssets), false), [banner], false))); // console.log(image);

  if (!(image && image.image && image.image.url)) {
    image = entity.openGraph;
  }

  var color = useComponentColor({
    cls: cls,
    prop: props.color,
    fallbacks: ['link', 'dark', 'primary'],
    invertedFallbacks: ['light']
  });
  var hoverColor = useComponentColor({
    cls: cls,
    prop: props.color,
    fallbacks: ['link-hover', 'mid-brand', 'primary'],
    invertedFallbacks: ['light-brand', 'light']
  });
  return React.createElement(My.Container, {
    _color: color,
    _hoverColor: hoverColor,
    entity: entity,
    className: cls.name(className)
  }, image && React.createElement(My.Image, {
    aspectRatio: aspectRatio,
    entity: image
  }), React.createElement(My.Body, null, React.createElement(My.Title, null, title || name), subtitle && React.createElement(My.Subtitle, null, subtitle), children));
};
ContentEntityThumbnailLink.defaultProps = ContentEntityThumbnailLinkDefaultProps;
ContentEntityThumbnailLink.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;